/* RESPONSIBLE TEAM: team-purchase */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  collectionKey: 'prices',
});
